module.exports = __webpack_public_path__ + "img/white-header-1.e22787b7.png";